import { FC, ReactNode, useEffect } from 'react';
import ProgressBar from 'components/onboarding/kyc/ProgressBar';
import { steps } from './SequenceSteps';
import useLoginStore from 'stores/loginStore';
import LogoBarStatic from 'components/onboarding/LogoBarStatic';
import WarningBar from 'components/onboarding/WarningBar';
import BackgroundVideo from 'components/onboarding/BackgroundVideo';
import Vault from 'components/onboarding/Vault';

const Login = () => {
  const { progressStep, setPercentCompleted, rotateVault } = useLoginStore();

  useEffect(() => {
    setPercentCompleted(steps[progressStep].progressOnMount);
    rotateVault(50);
  }, [progressStep]);

  return (
    <div className="grid w-full h-full place-content-center">
      <BackgroundVideo />
      <Vault fadeInImmediately />

      <div className="grid grid-rows-[auto_auto_1fr] gap-[8px] absolute top-0 left-0 w-screen h-full text-center justify-center">
        <WarningBar />
        <LogoBarStatic />
        <div className="grid w-full h-full grid-rows-[1fr_auto] gap-[30px] pb-[30px]">
          {steps[progressStep].component}
          <div>
            <ProgressBar />
          </div>
        </div>
      </div>
    </div>
  );
};

export const SequenceItem: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="grid w-full h-full grid-rows-[1fr_auto] gap-[30px]">
    {children}
  </div>
);

export default Login;
